import axios from 'axios'
import forge from 'node-forge'

import {
  getApplicationRsaPublicKeyUrl,
  getGeneralInsuranceRsaPublicKeyUrl,
  getProtectionRsaPublicKeyUrl,
} from '../runtimeConfig/runtimeConfig'

export type PublicKey = forge.pki.rsa.PublicKey
export type StringObj = { [key: string]: string }
export type EncryptFn = (value: string) => Promise<string>

const SCHEME = 'RSA-OAEP'
const SCHEME_OPTIONS = { md: forge.md.sha256.create() }

const encryptAndEncode = (publicKey: PublicKey, value: string) => {
  const ciphertext = publicKey.encrypt(value, SCHEME, SCHEME_OPTIONS)
  return forge.util.encode64(ciphertext)
}

// The public keys are available via our file server rather than the application build,
// that way we can perform a key rotation without having to re-build or re-deploy the
// application. The URL arrives as a getter so encrypting nothing stays a no-op that needs
// no configuration, and so the configured value is read at call time rather than at import.
const fetchAndEncrypt = async (value: string, getPublicKeyUrl: () => string) => {
  if (value === '') return ''
  const response = await axios(getPublicKeyUrl())
  const publicPem = response.data
  const publicKey = forge.pki.publicKeyFromPem(publicPem)
  return encryptAndEncode(publicKey, value)
}

export const encryptGiData: EncryptFn = async (value: string) => {
  return fetchAndEncrypt(value, getGeneralInsuranceRsaPublicKeyUrl)
}

export const encryptProtectionData: EncryptFn = async (value: string) => {
  return await fetchAndEncrypt(value, getProtectionRsaPublicKeyUrl)
}

export const encryptApplicationData: EncryptFn = async (value: string) => {
  return fetchAndEncrypt(value, getApplicationRsaPublicKeyUrl)
}
